module.exports = {
  Docker: require("./Docker"),
  LoadingStrategy: require("./LoadingStrategy"),
  Local: require("./Local"),
  Native: require("./Native"),
  VersionRange: require("./VersionRange")
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/compilerSupplier/loadingStrategies/index.js
// module id = 2690
// module chunks = 0 1